import { render, staticRenderFns } from "./showGongShiShenHeDialog.vue?vue&type=template&id=bfa2ac20&scoped=true&"
import script from "./showGongShiShenHeDialog.vue?vue&type=script&lang=js&"
export * from "./showGongShiShenHeDialog.vue?vue&type=script&lang=js&"
import style0 from "./showGongShiShenHeDialog.vue?vue&type=style&index=0&id=bfa2ac20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa2ac20",
  null
  
)

export default component.exports